export default {
    walletBalance: "Wallet Balance",
    collect:"Collect",
    approve:"Approve",
    ticket: "License",
    category: "Category",
    sortBy: "Sort By",
    issue: "Issue",
    confirm: "Confirm",
    detail: "Detail",
    stakingType: "Collateral",
    stakingTypeInfo: "To prevent issuer from confirming result viciously,please stake tokens or current NFT.",
    subscriptionAmount: "Subscription Amount",
    subscription: "Subscription",
    subscribe:"Buy",
    max: "Max",
    marketClosed: "Market Closed",
    add: "Add",
    verifiedNFT: "Check Verified License",
    select: "Select",
    selected: "Selected",
    moreNFT: "Get more License",
    forecastEvent: "Event",
    subscribeEndDate: "Last Trading Time",
    specifyLastTradingDate: "Specify Last Trading Time",
    specifyExpiryDate: "Specify Expiry Time",
    endDate: "End Time",
    validityPeriod: "Expiration Time",
    marketEndDate: "Expiration Time",
    liquidityMin:"Liquidity Min",
    premiumMin:"Premium Min",
    paymentCurrency: "Payment Currency",
    defaultOdds: "Default Leverage",
    setDefaultOdds: "Set Leverage",
    minInvestAmout: "Set The Minimum Investment Amount",
    depositMargin: "Add Liquidity",
    totalPayment: "Total Payment",
    rewards: "Rewards",
    rewardRate: "Reward Rate",
    release: "Release",
    fee: "Fee",
    marginFeeRate: "Fee Rate",
    cdsInfoOne: "When issue a prediction product, you have to stake the margin, set the default odds and the minimum investment amount.",
    cdsInfoTwo: "Unparticipating margin can be withdrawn at any time.",
    cdsInfoThree: "If more than 1 of the users choose to appeal the judgment result, the community governance mechanism will be initiated to determine whether the prediction event has occurred.",
    deposited: "Invested",
    issued: "Issued",
    deposit: "Deposit",
    depositedCDS: "invested products",
    totalProfit: "Total Profit",
    allOrDeposited: "Total/Deposited",
    rewardsOrProfit: "Rewards/Profit",
    estimatedInvested:"Estimated/Invested",
    profit: "Profit",
    yesterdayProfit: "Profit Yesterday",
    status: "Status",
    eventConfirming: "Event confirming",
    appeal: "Appeal",
    appealing: "Appealing",
    appealFailed: "Appeal Failed",
    occured: "Occured",
    notOccured: "Not Occured",
    governanceMechanism: "Initiate governance mechanism when the number of appeal exceeds one person.",
    appealLimit: "The number of appeal is not more than one person.",
    waitResult: "Waiting For Appeal Result",
    frozenMargin: "Frozen Margin",
    marginBalance: "Margin balance",
    balance: "Balance",
    cash: 'Cash',
    createNew: 'Create New',
    withdraw: "Withdraw",
    endTime: "Countdown To End",
    guaranteeing: "InProgress",
    guaranteeingEvent:"Prediction in progress",
    confirmsEventAdvance:"Event confirms occured in advance.",
    waitConfirmation:"Event is waiting for confirmation.",
    triggerEvent: "Event is confirmed to be occured.",
    notTriggerEvent: "Event  does not occur.",
    defaultChallenging:"Event occured, and is on challenging.",
    notDefaultChallenging:"Event did not occur, and is on challenging.",
    defaultChallengeFailed:"Event occured,and challenge failed.",
    notDefaultChallengeFailed:"Event did not occur,and challenge failed.",
    defaultWaitingResult:"Event occured,and is waiting for governance mechanism results.",
    notDefaultWaitingResult:"Event did not occur,and is waiting for governance mechanism results.",
    defaultGovernanceMechanism:"Governance mechanism confirms event occured.",
    notDefaultGovernanceMechanism:"Governance mechanism confirms that event does not occur.",
    cancel: "Cancel",
    defaultAhead:"Occured Ahead",
    occur: "Occured",
    notOccur: "Not occured",
    stakingToChallenge:"Staking to Challenge",
    challenged:"Challenged",
    checking: "Checking",
    fail: "Fail",


    appealInfoOne: 'If you think that the judgment of the current prediction event deviates from the facts, you can "Challenge" and start the governance mechanism to finally determine the current prediction result.',
    check: "Check",
    contentIllegal: "Prediction event involves content illegal, please edit the content again to issue",
    subscribed: "Invested products",
    receivingCompensation: "Pending",
    received: "Total Payoff",
    receive: "Receive",
    compensationAmount: "Occured compensation amount",
    liquidity: "Liquidity",
    injectLiquidity: "Inject Liquidity",
    uRLContent:"URL/Content",
    resolutionSource:"Resolution Source",
    textareaInfo: "Please describe this event briefly.",
    language: 'Language',
    theme: "Theme",
    network: "Network",

    // 新增：补齐模板使用的顶层键，避免 vue-i18n 警告
    home: "Home",
    market: "Market",
    markets: "Markets",
    portfolio: "Portfolio",
    license: "License",
    myPositions: "My Positions",
    history: "History",
    inputSearchText: "Please enter search content",
    predictionProduct: "Prediction product",
    listYourToken: "List your token",
    description: "Description",
    setResultModalTitle: "Set Result:",
    cancelModalTitle: "Cancel",
    cancelIrreversible: "Cancellation is irreversible.",
    challengeModalTitle: "Challenge",
    challengeStakeIntro: "if there is deviation in fact, will be returned to you.",
    challengeStakeButton: "PRDS to Challenge",

    issuerResult: "Issuer Result",
    daoResult: "DAO Result",
    waitingGovernanceResult: "Event is waiting for governance mechanism results.",
    eventFinished: "Event is Finished.",
    recycleTicket: "Recycle ticket",
    eventCancelled: "Event has been cancelled.",
    challenge: "Challenge",
    share: "Share",
    USDT: "USDT",

        licenses: "Licenses",
        prediLicense: "Predi License",
        issuableQuantity: "Issuable quantity",
        disabled: "Disabled",
        battleImage: "Battle Image",
        upload: "Upload",
        showSample: "Show Sample",
        battleInformation: "Battle Information",
        baseToken: "Base Token",
        collateral: "Collateral",
        currentLicense: "Current License",
        predictionProject: "Prediction Project:",
        issueExpireIntro: "At the expiration time, those who have chosen the correct option will share tokens from the product pool based on their participation shares.",
        issueParticipateUntil: "Users can participate in this product until",
        issueConfirmAdvance: "The result can be confirmed in advance by issuer, if the event occurs before expiration time.",
        issueChallengeWithin7Days: "If the participants disagree with the result of event confirmed by issuer, they can \"Challenge\" it within 7 days of confirmation.",
        issueAttention: "Attention: Predi is committed to fostering entertainment and social experiences. All forms of gambling-related activities are strictly prohibited on this platform.",
        eventSampleTitle: "Event",
        issueSampleCrypto: "[Crypto] What will be Bitcoin's price range at the end of 2025?",
        issueSampleFinance: "[Finance] What will be the U.S. Federal Reserve's interest rate decision in Q3 2025?",
        issueSampleTechnology: "[Technology] Which company will launch the first fully autonomous AI-driven robot assistant?",
        issueSampleSports: "[Sports] Which team will win the 2026 FIFA World Cup?",
        issueSampleSociety: "[Society] Which social media platform will have the most monthly active users in 2025?",
        issueSampleOthers: "[Others] When will the Russia-Ukraine war end?",
        issuerResult: "Issuer Result",
        daoResult: "DAO Result",
        predictionToken: "Prediction Token",
        issuer: "Issuer",
        issuerProfit: "Issuer profit",

    donations: "Donations",

    // Issue.vue notifications (top-level)
    issueMsgPleaseSelectLicense: "Please select a License",
    issueMsgLicenseCannotBeStaked: "License cannot be staked",
    issueMsgNetworkNotConnected: "Network not connected",
    issueMsgEventEmpty: "Event is empty",
    issueMsgSelectLicense: "Select a License",
    issueMsgLastTradingDateEmpty: "Last trading time is empty",
    issueMsgExpirationDateEmpty: "Expiration time is empty",
    issueMsgOptionsEmpty: "Options cannot be empty",
    issueMsgOptionsLessThanTwo: "There cannot be less than two options",
    issueMsgOptionEmpty: "Option content cannot be empty",
    issueMsgOptionRepeated: "Option content cannot be repeated",
    issueMsgLastTradingDateGreaterThanToday: "Last trading time must be greater than today",
    issueMsgLastTradingDateGreaterThanExpirationDate: "Last trading time is greater than expiration time",
    issueMsgEventEndDateGreaterThanRentalEndDate: "Event end time {eventEndDate} is greater than rental end time {rentalEndDate}",
    issueMsgInsufficientBalance: "Insufficient balance",
    issueMsgTransactionFailed: "Transaction failed",
    issueMsgIssueSuccess: "Issue success",
    issueMsgTransactionCancelled: "Transaction cancelled",
    
    empowering: "Empowering Visionaries Predicting Futures",

    createYourOwnMarket: "Create Your Own Market",
    buyTicket: "Buy a Ticket",
    amount: "Amount",

    short:{
        confirmsEventAdvance:"Occured In Advance",
        waitConfirmation:"Waiting For Confirmation",
        defaultChallenging:"Occured-Challenging",
        notDefaultChallenging:"Not Occured-Challenging",
        defaultChallengeFailed:"Occured-Challenge Failed",
        notDefaultChallengeFailed:"Not Occured-Challenge Failed",
        defaultWaitingResult:"Occured-Governing",
        notDefaultWaitingResult:"Not Occured-Governing",
        defaultGovernanceMechanism:"Occured-Governance Confirmed",
        notDefaultGovernanceMechanism:"Not Occured-Governance Confirmed"
    },

    wallet: {
        openWallet: "Open Wallet",
        connectWallet: "Connect Wallet",
        connectingWallet: 'Connecting Wallet',
        connectYourWallet: "Connect your wallet",
        disconnect: "Disconnect",
        wrongNetwork: "Wrong Network"
    },
	
    NFT: {
        getPrediLicense: "GET Predi License",
        referralRewards: "Referral Rewards",
        mintYourLicence: "Mint your licence",
        usageRights: "Usage Rights",
        issuePredictionProducts: "Issue Prediction Products",
        governance: "Governance",
        properties: "Properties",
        tradable: "Tradable",
        rentable: "Rentable",
        usable: "Usable",
        marketsToIssue: "Markets to Issue",
        times: "Times",
        availableTimes: "Available Times",
        ticketId: "Ticket ID",
        cancelRentHint: "This License is on renting, please cancel it and then you can sell it.",
        seeMore: "See More",
        sell: "Sell",
        rent: "Rent",
        share: "Share",
        USDT: "USDT",
        common: "Common",
        scarcity: "Scarcity",
        attributive: "Attributive",
        numbers: "Issue Number",
        issueTip:"Issue 10 prediction Markets/License",
        price: "Price",
        success: "Success",
        getNFT: "Get License successfully",
        issueCDS: "Issue Predi Markets",
        buyNow: "Buy Now",
        mintNow: "Mint Now",
        rule: "Rule",
        comingSoon: "Coming Soon!",
        type: "Type",
        from: "From",
        to: "To",
        me: "Me",
        rented: "Rented",
        sold: "Sold",
        tabGetLicense: "GET License",
        tabMyLicense: "My License",
        bought: "Bought",
        boughtProducts: "Bought products",
        investedProducts: "Invested products",
        issuedProducts: "Issued products",
        positions: "Positions",
        options: "Options",
        all: "All",
        volume: "Volume",
        newest: "Newest",
        price: "Price",
        pending: "Pending",
        audit: "Audit",
        loading: "Loading",
        home: "Home",
        market: "Market",
        markets: "Markets",
        portfolio: "Portfolio",
        license: "License",
        myPositions: "My Positions",
        challengeCredit: "Challenge credit",
        challengeStatus: "Challenge status",
        succeed: "Succeed",
        wait: "Wait",
        return: "Return",
        waitChallenge: "Event is waiting for challenge.",
        waitingGovernanceResult: "Event is waiting for governance mechanism results.",
        eventFinished: "Event is Finished.",
        cancelled: "Cancelled",
        predictionProduct: "Prediction product",
        complaintCountdown: "Complaint Countdown",
        setResult: "Set result",
        challenge: "Challenge",
        recycleTicket: "Recycle ticket",
        eventCancelled: "Event has been cancelled.",
        auditChecking: "Audit Checking",
        insufficientFunds: "Insufficient Funds",
        buy: "Buy",
        listYourToken: "List your token",
        setResultModalTitle: "Set Result:",
        cancelModalTitle: "Cancel",
        cancelIrreversible: "Cancellation is irreversible.",
        challengeModalTitle: "Challenge",
        challengeStakeIntro: "if there is deviation in fact, will be returned to you.",
        challengeStakeButton: "PRDS to Challenge",
        history: "History",
        seeMore: "See More"
    },

    claim: {
        title: "Claim PRDs For Free",
        subtitle: "Get your PRDs tokens with just one click",
        walletAddress: "Wallet Address",
        status: "Status",
        connectWalletFirst: "Please Connect Wallet First",
        eligibility: {
            claimed: "You have claimed already",
            eligible: "You are eligible to claim",
            error: "Error checking eligibility"
        },
        button: {
            claim: "Claim",
            alreadyClaimed: "Already Claimed",
            connect: "Connect"
        },
        footerNotice: "Each wallet can claim only once. Make sure you're connected to the correct network.",
        messages: {
            connectFirst: "Please connect your wallet first",
            claimSuccess: "Claim successful!",
            claimFailed: "Claim failed, please try again later",
            txCancelled: "Transaction Cancelled",
            onlyOnce: "Each user can only claim once",
            insufficientBalance: "Insufficient balance in contract, please try again later"
        }
    }
}


